export default {
  common: {
    loading: 'Đang tải',
    confirm: 'Xác nhận',
    cancel: 'Hủy',
    save: 'Lưu',
    back: 'Quay lại',
    copy: 'Sao chép',
    delete: 'Xóa',
    copySuccess: 'Sao chép thành công',
    editSuccess: 'Chỉnh sửa thành công',
    deleteSuccess: 'Xóa thành công',
    modifySuccess: 'Cập nhật thành công',
    cannotBeEmpty: 'Không được để trống',
    noContent: 'Không có nội dung',
    noData: 'Không có dữ liệu liên quan',
    noMoreData: 'Không còn dữ liệu',
    iKnow: 'Tôi đã hiểu',
    selectService: 'Chọn nhà cung cấp',
    sendSuccess: 'Gửi thành công',
  },
  billHome: {
    recharge: 'Nạp tiền & Thanh toán',
    coupon: 'Phiếu giảm giá',
    rechargeNow: 'Nạp ngay',
    cost: 'Phí thoại',
    flow: 'Dữ liệu',
    rechargeNotice: 'Lưu ý khi nạp tiền',
    rechargeCost: 'Nạp phí thoại',
    rechargeFlow: 'Nạp dữ liệu',
    rechargeAmount: 'Số tiền nạp',
    rechargePackage: 'Gói nạp tiền',
    discount: 'Đã giảm giá',
    confirmTxt: 'Xác nhận chính xác',
    confirmTxt1: 'Tôi hiểu rồi',
    actualPayment: 'Thành tiền',
    selectCoupon: 'Chọn phiếu giảm giá',
    useRule: 'Quy tắc sử dụng',
    availableCoupon: 'Phiếu có thể dùng',
    unavailableCoupon: 'Phiếu không thể dùng',
    noAvailableCoupon: 'Chưa có phiếu giảm giá',
    selectPhone: 'Chọn số điện thoại',
    pleaseInputPhone: 'Vui lòng nhập số điện thoại',
    couponCount: 'Phiếu giảm giá khả dụng',
    pleaseInputCorrectPhone: 'Vui lòng nhập số điện thoại chính xác',
    pleaseSelectPackage: 'Vui lòng chọn gói nạp tiền',
  },
  accountManage: {
    title: 'Quản lý tài khoản',
    edit: 'Chỉnh sửa',
    deleteConfirm: 'Xác nhận xóa',
  },
  rechargeDetail: {
    title: 'Chi tiết thanh toán',
    continuePay: 'Tiếp tục thanh toán',
  },
  feesExpense: {
    title: 'Lịch sử thanh toán',
    recharge: 'Số điện thoại',
    electricity: 'Tiền điện',
    internet: 'Cước Internet',
    water: 'Tiền nước',
    photo: 'Chụp ảnh',
    complete: 'Hoàn tất',
    manage: 'Quản lý',
    allSelect: 'Chọn tất cả',
    selected: 'Đã chọn',
    deleteConfirm: 'Xóa',
    deleteRecord: 'giao dịch này?',
    noDataAction: 'Không có dữ liệu để thao tác',
    pleaseSelect: 'Vui lòng chọn giao dịch cần xóa',
    feesNotice: 'Lưu ý khi thanh toán',
  },
  formCom: {
    upload: 'Nhấn để tải lên',
    saveAccount: 'Lưu hoặc cập nhật tài khoản',
    createOrder: 'Tạo đơn hàng',
    rechargeIng: 'Đang nạp tiền',
    rechargeNow: 'Nạp ngay',
    serviceProvider: 'Nhà cung cấp',
    billImage: 'Hình ảnh hóa đơn',
    returnSelect: 'Quay lại chọn lại',
    electricity: 'Hóa đơn điện',
    internet: 'Hóa đơn internet',
    water: 'Hóa đơn nước',
    photo: 'Thanh toán qua ảnh',
    life: 'Hóa đơn sinh hoạt',
    uploadFail: 'Tải lên thất bại, vui lòng thử lại',
    pleaseFill: 'Vui lòng điền đầy đủ thông tin',
    submitSuccess: 'Gửi thành công, vui lòng chờ thanh toán',
  },
  langPop: {
    selectLang: 'Chọn ngôn ngữ',
  },
  loginPop: {
    loginOrRegister: 'Vui lòng đăng nhập hoặc đăng ký tài khoản Kuaizi',
    confirmLogout: 'Bạn có chắc muốn đăng xuất?',
    toLogin: 'Đăng nhập',
    logoutSuccess: 'Đăng xuất thành công',
  },
  newMe: {
    myOrder: 'Đơn hàng của tôi',
    coupon: 'Phiếu giảm giá',
    accountManage: 'Quản lý tài khoản',
    orderCount: 'đơn đang xử lý',
    couponCount: 'phiếu',
    account: 'Tài khoản',
    logout: 'Đăng xuất',
  },
  coupons: {
    all: 'Tất cả',
    coupon: 'Phiếu giảm giá',
    historyCoupon: 'Phiếu đã dùng/hết hạn',
    use: 'Dùng ngay',
    validityPeriod: 'Thời hạn sử dụng',
    useRule: 'Quy tắc sử dụng',
    used: 'Đã dùng',
    expired: 'Đã hết hạn',
  },
  accountSeting: {
    title: 'Cài đặt',
    personalInfo: 'Thông tin cá nhân',
    modifyPayPassword: 'Đổi mật khẩu thanh toán',
    modifyLoginPassword: 'Đổi mật khẩu đăng nhập',
    phone: 'Số điện thoại',
    code: 'Mã xác minh',
    loginPassword: 'Mật khẩu đăng nhập',
    confirmModify: 'Xác nhận thay đổi',
    noCode: 'Không nhận được mã?',
    passwordPlaceholder: '8–16 ký tự bao gồm chữ và số',
    inputCorrectPhone: 'Nhập số điện thoại hợp lệ',
    afterGetCode: 'có thể nhận lại sau',
    getCode: 'Lấy mã',
    input6DigitPassword: 'Nhập mật khẩu 6 chữ số',
    twoInputPasswordNotConsistent: 'Mật khẩu không khớp',
    placeholderCode: 'Nhập mã xác minh',
    confirmPassword: 'Xác nhận mật khẩu',
    password: 'Mật khẩu',
    submit: 'Gửi',
    avatar: 'Ảnh đại diện',
    userName: 'Tên người dùng',
    nickName: 'Biệt danh',
    modifyPhone: 'Đổi số điện thoại',
    nickNamePlaceholder: 'Thể hiện cá tính của bạn',
    sex: 'Giới tính',
    male: 'Nam',
    female: 'Nữ',
    email: 'Email',
    emailPlaceholder: 'Thêm email để khôi phục mật khẩu',
    pleaseCompletePersonalData: 'Vui lòng hoàn tất thông tin cá nhân để trải nghiệm nhiều tính năng hơn',
    bindNewPhone: 'Liên kết số điện thoại mới',
    oldPhone: 'Số điện thoại cũ',
    completeVerification: 'Xác minh hoàn tất',
    changePayPasswordTitle: 'Đổi mật khẩu thanh toán',
    changePasswordTitle: 'Đổi mật khẩu',
    oldPhoneTitle: 'Xác minh số điện thoại cũ',
    editInfoTitle: 'Chỉnh sửa thông tin cá nhân',
    areaCode: 'Mã vùng',
  },
}
